module.exports = __webpack_public_path__ + "img/kma_gallery9.44f9c6a6.jpg";